export const TEMPLATE_LAYOUT_AUTH_DEFAULT = {
    header: {
        show: true,
        navigationStyle: "auth"
    },
    body: {
      backButton: false
    }
}

export const TEMPLATE_LAYOUT_AUTH_HEADER_FULL = {
    header: {
        show: true,
        navigationStyle: "full"
    },
    body: {
      backButton: false
    }
}

export const TEMPLATE_LAYOUT_AUTH_NO_HEADER = {
    header: {
        show: false
    },
    body: {
      backButton: false
    }
}

export const TEMPLATE_LAYOUT_AUTH_PROFILE_CHILDREN = {
  header: {
    show: true,
    navigationStyle: "full"
  },
  body: {
    backButton: true
  }
}

export const GENERIC_ERROR_MESSAGE = "Si è verificato un errore. Aggiornare la pagina o contattare l'assistenza";

export interface User {
    eventName: string
    remember: boolean
    provider: string
    loginMode: string
    newUser: boolean
    UIDSignature: string
    signatureTimestamp: string
    UID: string
    profile: Profile
    data: any
    dataCenter: string
    isGlobal: boolean
    fullEventName: string
    source: string
}

export interface Profile {
    firstName: string
    lastName: string
    email: string
    locale: string
}

export class ProfileToUnify {
    fiscalCode?: string;
    email?: string;
    name?: string;
    lastName?: string;
    uid?: string;
}

export interface ScreenSetBasicOptions {
  screenSet?: string,
  startScreen?: string,
  containerID?: string,
  onSubmit?: (e: any) => void,
  onError?: (e: any) => void,
  onAfterSubmit?: (e: any) => void,
  onAfterScreenLoad?: (e: any) => void,
  onHide?: (e: any) => void
}

export interface responseUserEmailVerification {
  email: string,
  isFakeEmail: boolean,
  isArt18: boolean,
  sessionInfo?: {
    cookieName: string
    cookieValue: string
  }
}

export type gigyaScreenEventType = 'onLogin' | 'onSubmit' | 'onAfterSubmit' | 'onError' | 'onHide' | 'onAfterScreenLoad'

export interface getUserJWTResponse {
  success: boolean,
  token?: string,
  message?: string
}
